import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from 'src/app/components/navbar/navbar.component';
import { FooterComponent } from 'src/app/components/footer/footer.component';

@Component({
	selector: 'app-shell',
	standalone: true,
	imports: [CommonModule, RouterOutlet, NavbarComponent, FooterComponent],
	templateUrl: './shell.component.html',
	styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
